(() => {
  'use strict';

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const normalizeBuildBoxLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = (link.getAttribute('href') || '').replace(/\/$/, '');
      const label = (link.textContent || '').trim().toLowerCase();
      if (href === '/collections/combos' || label === 'combos' || label === 'build your own box') {
        link.setAttribute('href', '/pages/build-your-own-box');
      }
    });
  };

  const enhanceProductCards = () => {
    const flavourMap = [
      ['himalayan', 'af-flavour--slate'],
      ['salt & pepper', 'af-flavour--slate'],
      ['peri peri', 'af-flavour--orange'],
      ['cream & onion', 'af-flavour--purple'],
      ['cheese & herbs', 'af-flavour--yellow'],
      ['pudina', 'af-flavour--green'],
      ['hing jeera', 'af-flavour--mustard'],
      ['chatpata', 'af-flavour--crimson'],
    ];

    document.querySelectorAll('product-card, .product-card, .card-product').forEach((card) => {
      const text = (card.textContent || '').toLowerCase();
      const match = flavourMap.find(([needle]) => text.includes(needle));
      if (match) card.classList.add(match[1]);
    });
  };

  const revealSections = () => {
    const targets = document.querySelectorAll('.shopify-section:not(:first-child)');
    targets.forEach((element) => element.classList.add('af-reveal'));

    if (!('IntersectionObserver' in window)) {
      targets.forEach((element) => element.classList.add('af-reveal--in'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('af-reveal--in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08 }
    );

    targets.forEach((element) => observer.observe(element));
  };

  const enableMobilePdpAccordions = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('.af-pdp-details details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open || !detail.parentElement) return;
        detail.parentElement.querySelectorAll('details').forEach((other) => {
          if (other !== detail) other.open = false;
        });
      });
    });
  };

  onReady(() => {
    document.documentElement.classList.add('af-js');
    normalizeBuildBoxLinks();
    enhanceProductCards();
    revealSections();
    enableMobilePdpAccordions();
  });

  document.addEventListener('shopify:section:load', () => {
    normalizeBuildBoxLinks();
    enhanceProductCards();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.af10-quickadd');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"], button');
    if (!button || button.disabled) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Cart add failed');

      button.textContent = 'ADDED ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    } catch (error) {
      console.error('AFTER FOUR quick add:', error);
      button.textContent = 'TRY AGAIN';
    } finally {
      window.setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1300);
    }
  });
})();
